// #ifdef APP-PLUS
import axios from 'axios';
import configJson from "../config.json";
const rootUrl = '/api';
const service = axios.create({
	baseURL: window.app.baseURL,
	timeout: 1000 * 60
});
// #endif
function post( url, data,config ) {
// #ifdef APP-PLUS
	return service.post( url, data ,config ).then(( res ) => Promise.resolve( res.data ));
// #endif
}
const captchaApi = {
  authFusionInit(params, url, config, productKey, ttt){
    return post(
			configJson[productKey].productLine === 'configserver'
				? `${url || rootUrl}/v2/captcha/fusion/authInit`
				: `${url || rootUrl}/authFusionInit${ttt || ''}`,
			params,
			config
		);
  },
  captchaFusionAuthCheck(params, url, config, productKey){
    return post(
			configJson[productKey].productLine === 'configserver'
				? `${url || rootUrl}/v2/captcha/fusion/authCheck`
				: `${url || rootUrl}/captchaFusionAuthCheck`,
			params,
			config
		);
  },
}
export default captchaApi;